/* The Pure Beauty — bloc produit (<tpb-product>) */
  /* Bloc produit : variantes (onglets de cure / liste), galerie, options du pack, upsells, vidéos. */
  (function () {
    if (customElements.get('tpb-product')) return;

    function money(cents) {
      if (window.TPB && typeof window.TPB.money === 'function') return window.TPB.money(cents);
      return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }

    class TpbProduct extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        var json = this.querySelector('script[data-product-variants]');
        try { this.variants = json ? JSON.parse(json.textContent) : []; } catch (e) { this.variants = []; }
        this.input = this.querySelector('[data-variant-input]');
        this.threshold = Number(this.getAttribute('data-free-threshold') || 0);
        this.current = this.find(this.input ? this.input.value : null);
        
        this.addEventListener('submit', function(e) {
          if (!e.target.matches('[data-tpb-product-form]')) return;

          // Empêche la soumission native et la redirection vers /cart.
          // Le gestionnaire AJAX existant conserve son fonctionnement.
          e.preventDefault();
        }, true);

        this.addEventListener('click', function (e) {
          var tab = e.target.closest('[data-variant-tab]');
          if (tab) { e.preventDefault(); self.select(tab.getAttribute('data-variant-id')); return; }
          var thumb = e.target.closest('[data-thumb]');
          if (thumb) {
            e.preventDefault();
            var id = thumb.classList.contains('is-active') ? thumb.getAttribute('data-first') : thumb.getAttribute('data-thumb');
            self.showMedia(id);
            return;
          }
          var ugc = e.target.closest('[data-ugc]');
          if (ugc) self.toggleVideo(ugc);
        });

        this.addEventListener('change', function (e) {
          var t = e.target;
          if (t.matches('[data-variant-picker]')) self.select(t.value);
          else if (t.matches('[data-extra-item]')) self.updateButtons();
          else if (t.matches('[data-upsell-select]')) self.updateUpsell(t);
        });

        this.addEventListener('keydown', function (e) {
          var tab = e.target.closest('[data-variant-tab]');
          if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
          var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-variant-tab]'));
          var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
          var next = tabs[(i + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); next.focus(); self.select(next.getAttribute('data-variant-id')); }
        });

        this.querySelectorAll('[data-ugc] video').forEach(function (video) {
          var item = video.closest('[data-ugc]');
          video.addEventListener('pause', function () { item.classList.remove('is-playing'); });
          video.addEventListener('play', function () { item.classList.add('is-playing'); });
        });

        if (this.current) {
          this.select(this.current.id);
        } else {
          this.updateButtons();
        }
           var gallery = this;
           var warm = function () {
             gallery.querySelectorAll('.tpb-pm__slide img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
           };
           if (document.readyState === 'complete') setTimeout(warm, 300);
           else window.addEventListener('load', function () { setTimeout(warm, 300); });
      }

      find(id) {
        id = String(id);
        for (var i = 0; i < this.variants.length; i++) {
          if (String(this.variants[i].id) === id) return this.variants[i];
        }
        return null;
      }

      select(id) {
        var v = this.find(id);
        if (!v) return;
        var self = this;
        var vid = String(v.id);
        var pos = this.variants.indexOf(v) + 1;
        this.current = v;
        if (this.input) this.input.value = v.id;

        this.querySelectorAll('[data-variant-show]').forEach(function (el) {
          el.hidden = el.getAttribute('data-variant-show') !== vid;
        });
        this.querySelectorAll('[data-variant-tab]').forEach(function (b) {
          var on = b.getAttribute('data-variant-id') === vid;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-variant-picker]').forEach(function (s) { s.value = vid; });
        this.querySelectorAll('[data-gift]').forEach(function (g) {
          g.classList.toggle('is-locked', pos < Number(g.getAttribute('data-unlock') || 1));
        });
        this.querySelectorAll('[data-free-ship]').forEach(function (el) {
          el.hidden = !(self.threshold > 0 && Number(v.price) >= self.threshold);
        });
        if (v.featured_media && v.featured_media.id) this.showMedia(String(v.featured_media.id));
        this.updateButtons();

        if (this.hasAttribute('data-update-url') && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
        this.dispatchEvent(new CustomEvent('tpb:variant:change', { bubbles: true, detail: { variant: v } }));
      }

      updateButtons() {
        var v = this.current;
        if (!v) return;
        var total = Number(v.price) || 0;
        this.querySelectorAll('[data-extra-item]').forEach(function (x) {
          if (x.checked && !x.disabled) total += Number(x.getAttribute('data-price') || 0);
        });
        this.querySelectorAll('[data-atc]').forEach(function (btn) {
          var label = btn.querySelector('[data-atc-label]');
          btn.disabled = !v.available;
          if (!label) return;
          label.textContent = v.available
            ? (btn.getAttribute('data-template') || '').replace('[prix]', money(total))
            : (btn.getAttribute('data-sold-out') || '');
        });
        this.querySelectorAll('[data-sticky-btn]').forEach(function (b) { b.disabled = !v.available; });
      }

      showMedia(id) {
        if (!id) return;
        var slides = this.querySelectorAll('[data-media-id]');
        var exists = Array.prototype.some.call(slides, function (s) { return s.getAttribute('data-media-id') === id; });
        if (!exists) return;
        slides.forEach(function (s) { s.hidden = s.getAttribute('data-media-id') !== id; });
        this.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-thumb') === id);
        });
      }

      updateUpsell(select) {
        var row = select.closest('.tpb-pm__ups-row');
        if (!row) return;
        // Affiche le prix (rendu en Liquid) de la variante choisie
        row.querySelectorAll('[data-upsell-variant]').forEach(function (el) {
          el.hidden = el.getAttribute('data-upsell-variant') !== select.value;
        });
        var btn = row.querySelector('[data-tpb-add]');
        if (!btn) return;
        btn.setAttribute('data-variant-id', select.value);
        if (btn.classList.contains('is-added') && btn.hasAttribute('data-label')) {
          btn.innerHTML = btn.getAttribute('data-label');
          btn.classList.remove('is-added');
        }
      }

      toggleVideo(item) {
        var video = item.querySelector('video');
        if (!video) return;
        if (video.paused) {
          this.querySelectorAll('[data-ugc] video').forEach(function (o) { if (o !== video) o.pause(); });
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      }
    }

    customElements.define('tpb-product', TpbProduct);
  })();
